

































































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SendMailQueueService from '@/service/SendMailQueueService'
import { SendMailQueue } from '@/domain/SendMailQueue'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class MasterMailTest extends Mixins(GlobalMixin) {
  sendMailQueueService = SendMailQueueService.instance
  to = ""
  subject = "テストメール"
  content = "このメールは、メール送信のテストです。"

  /**
   * 送信ボタン
   */
  onSend() {
    this.showLoading()
    const sendMailQueue = new SendMailQueue({to: this.to, subject: this.subject, content: this.content})
    this.sendMailQueueService.push(sendMailQueue)
      .then(() => {
          this.alert("メールの受信を確認してください", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.hideLoading()
      })
  }

}
